import ApiClient from './ApiClient';

class AccountUserAPI extends ApiClient {
  constructor() {
    super('users', { accountScoped: true });
  }

  fetch() {
    return this.get(`${this.url}`);
  }
}

export default new AccountUserAPI();
